// extracted by mini-css-extract-plugin
export default {"section-title":"Kvd7zn","sectionTitle":"Kvd7zn"};